import { LogOut, User } from "lucide-react"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useAuthStore } from "@/stores/auth-store"

export function AppHeader() {
  const navigate = useNavigate()
  const staff = useAuthStore((s) => s.staff)
  const logout = useAuthStore((s) => s.logout)

  const handleLogout = async () => {
    await logout()
    navigate("/login", { replace: true })
  }

  if (!staff) return null

  return (
    <header className="flex items-center justify-between border-b border-border bg-background px-6 py-3">
      <div className="text-lg font-semibold">CUE 员工后台</div>
      <div className="flex items-center gap-4">
        <Link
          to="/profile"
          className="flex items-center gap-2 text-sm hover:bg-accent rounded-md px-2 py-1"
        >
          <User className="h-4 w-4 text-muted-foreground" />
          <span className="font-medium">{staff.name_display}</span>
          <span className="text-xs text-muted-foreground">({staff.role})</span>
          {staff.must_change_password && (
            <span className="rounded bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200 px-1.5 py-0.5 text-[10px]">
              需改密
            </span>
          )}
        </Link>
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          <LogOut className="h-4 w-4 mr-1" />
          登出
        </Button>
      </div>
    </header>
  )
}
